/**
 * Subscription Tiles Item used in the home page
 */
export class SubscriptionTilesItem {
  constructor(
    public title: string,
    public slug: string,
    public description?: string,
    public imageIcon?: string,
    public imageUrl?: string,
    public imageWidth?: string,
    public imageHeight?: string
  ) {}
}
